/**
 * Determines if the current environment is a native WebView (Android or iOS).
 * This function checks the user agent string to identify whether the app is running
 * inside a WebView on Android or iOS platforms. It distinguishes iOS WebView from Safari
 * and Android WebView using specific patterns in the user agent.
 *
 * @returns {boolean} - Returns true if the environment is a WebView, false otherwise.
 *
 * Author: shhuan
 * Last Updated: June 10, 2025
 */
export const isInWebView = () => {
  const ua = navigator.userAgent;
  const isAndroidWebView = /Android/.test(ua) && /wv/.test(ua);
  const isIOS = /iPhone|iPad|iPod/.test(ua);
  const isSafari = /Safari/.test(ua);
  const isIOSWebView = isIOS && !isSafari;
  return isAndroidWebView || isIOSWebView;
};